import { Form } from 'antd';
import type { FormInstance } from 'antd/es/form';

import type { PaymentFormValues } from '../types';

export interface PaymentFormWatchedValues {
  agreeCharge: boolean | undefined;
  agreeTerms: boolean | undefined;
  paymentPlan: PaymentFormValues['paymentPlan'] | undefined;
  splitPayInFull: boolean | undefined;
  splitInstalmentDown: boolean | undefined;
  instalmentMonths: PaymentFormValues['instalmentMonths'] | undefined;
  downPaymentAmount: string | undefined;
  billingAddressSameAsFirst: boolean | undefined;
  billing1AddressLine: string | undefined;
  billing1City: string | undefined;
  billing1Country: string | undefined;
  billing1PostalCode: string | undefined;
}

export function usePaymentFormWatchedValues(
  form: FormInstance<PaymentFormValues>,
): PaymentFormWatchedValues {
  const agreeCharge = Form.useWatch('agreeCharge', form);
  const agreeTerms = Form.useWatch('agreeTerms', form);
  const paymentPlan = Form.useWatch('paymentPlan', form);
  const splitPayInFull = Form.useWatch('splitPayInFull', form);
  const splitInstalmentDown = Form.useWatch('splitInstalmentDown', form);
  const instalmentMonths = Form.useWatch('instalmentMonths', form);
  const downPaymentAmount = Form.useWatch('downPaymentAmount', form);
  const billingAddressSameAsFirst = Form.useWatch('billingAddressSameAsFirst', form);
  const billing1AddressLine = Form.useWatch('addressLine', form);
  const billing1City = Form.useWatch('city', form);
  const billing1Country = Form.useWatch('country', form);
  const billing1PostalCode = Form.useWatch('postalCode', form);

  return {
    agreeCharge,
    agreeTerms,
    paymentPlan,
    splitPayInFull,
    splitInstalmentDown,
    instalmentMonths,
    downPaymentAmount,
    billingAddressSameAsFirst,
    billing1AddressLine,
    billing1City,
    billing1Country,
    billing1PostalCode,
  };
}
